import { jsx as _jsx } from "react/jsx-runtime";
import { useTribeClient } from '@tribeplatform/react-sdk';
import { ErrorBoundary as EBComponent } from './ErrorBoundary';
export const ErrorBoundary = ({ children }) => {
    const { config } = useTribeClient();
    if (!(config === null || config === void 0 ? void 0 : config.errorBoundary)) {
        return children;
    }
    return (_jsx(EBComponent, { fallback: config.errorBoundary.fallback, onError: config.errorBoundary.handler, children: children }, void 0));
};
//# sourceMappingURL=index.js.map